import { Menu } from "primereact/menu";
import { useRef, useState } from "react";
import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

import {
  ModalAddCode,
  ModalPrivateSource,
  ModalAddSourceArchive,
} from "components/modals";
import {
  labelAddCode,
  labelAddSourceArchive,
  labelAddSourcePrivate,
} from "_constants";
import { useAppDispatch } from "store/store";
import { resetCodesState } from "store/slicer/GestioneCodeSlice";
import { resetStateSources } from "store/slicer/GestioneSourcesSlice";

export const ButtonChoiceAddProject = ({
  projectId,
}: {
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const menu = useRef<any>(null);
  const [showModalAddCode, setShowModalAddCode] = useState(false);
  const [showModalPrivateSource, setShowModalPrivateSource] = useState(false);
  const [showModalAddSourceArchive, setShowModalAddSourceArchive] =
    useState(false);

  const dropdownOptions = [
    {
      label: labelAddCode,
      icon: PrimeIcons.DATABASE,
      command: () => {
        dispatch(resetCodesState());
        setShowModalAddCode(true);
      },
    },
    {
      label: labelAddSourceArchive,
      icon: PrimeIcons.FOLDER_OPEN,
      command: () => {
        dispatch(resetStateSources());
        setShowModalAddSourceArchive(true);
      },
    },
    {
      label: labelAddSourcePrivate,
      icon: PrimeIcons.UPLOAD,
      command: () => setShowModalPrivateSource(true),
    },
  ];

  return (
    <>
      <Menu
        model={dropdownOptions}
        popup
        ref={menu}
        className="menu-add-project"
      />
      <Button
        icon={PrimeIcons.PLUS}
        className="button-add-project"
        onClick={(event) => menu.current.toggle(event)}
      />
      {showModalAddCode && (
        <ModalAddCode
          projectId={projectId}
          modalVisibile={showModalAddCode}
          onClose={() => setShowModalAddCode(false)}
        />
      )}
      {showModalAddSourceArchive && (
        <ModalAddSourceArchive
          projectId={projectId}
          modalVisibile={showModalAddSourceArchive}
          onClose={() => setShowModalAddSourceArchive(false)}
        />
      )}
      {showModalPrivateSource && (
        <ModalPrivateSource
          projectId={projectId}
          modalVisibile={showModalPrivateSource}
          onClose={() => setShowModalPrivateSource(false)}
        />
      )}
    </>
  );
};
